import React from 'react'
import { useEffect, useState } from "react";
import API from '../utils/api.js';
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Container, Table } from 'react-bootstrap';
import { formatearFecha } from '../utils/FormatearFecha.js';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale,LinearScale,BarElement,Title } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';


ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title);

const data_inicio_donut = {
    labels: ['Sin resultados'],
    datasets: [
        {
            data: [0],
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)'
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)'
            ],
            borderWidth: 1,
        },
    ],
};


const ProximosVencimientos = () => {

    
  var url = API.urlAPI
  const urlPrestamosVencimientos = url + "prestamos/ProximosVencimientos"
  const urlPrestamosVencimientosRes = url + "prestamos/ResumenProximosVencimientos"
  
  const [dataDonut, setDataDonut] = useState(data_inicio_donut)

  const [listProximosVenc, setListProximosVenc] = useState([])


  const optionsBar = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        }
    }
};


  const fetchDataDonut = async() => {
    let resp = await fetch(urlPrestamosVencimientosRes)
    let dataBarra = await resp.json()

  
  let modeloDonut = {
    labels: dataBarra.map((data) => data.Estado),
    datasets: [
        {
            data:  dataBarra.map((data) => data.CantCuotas),
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                
                'rgba(75, 192, 192, 0.2)'
            ],
            borderColor: [
                
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                
                'rgba(75, 192, 192, 1)'
            ],
            borderWidth: 1
        },
    ],
}
  setDataDonut(modeloDonut)
  

  }


  const fetchTablaPrestamos = async () => {
    let res = await fetch(urlPrestamosVencimientos)
    let data = await res.json()
    setListProximosVenc(data)
  }

  useEffect(() => {
    fetchTablaPrestamos()
    fetchDataDonut()
  }, [])

  const getColor = (estadoFila) => {
    if (estadoFila == "Atrasado") return 'rgba(255, 99, 132, 0.2)';
    if (estadoFila == "Proximo a vencer") return 'rgba(255, 206, 86, 0.2)';
    if (estadoFila == "Pendiente") return 'rgba(54, 162, 235, 0.2)';

    return '';
  };

  return (
    <>
    <br></br>
      <Container>
        <Card>
          <Card.Header style={{ background: "#005187", color: "white" }}><h5>Proximos Vencimientos 15 días</h5></Card.Header>
          <Card.Body>
          <div style={{ height: 350 }}>
                                <Doughnut options={optionsBar} data={dataDonut} />
                            </div>
                            <br></br>
          <Table bordered hover responsive>
                                                    <thead>
                                                        <tr>
                                                            <th>Fecha Vencimiento</th>
                                                            <th>Estado</th>
                                                            <th>N° Crédito</th>
                                                            <th>Cliente</th>
                                                            <th>Cuota</th>
                                                            <th>Cuota Con Interes</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            (listProximosVenc.length < 1) ? (
                                                                <tr>
                                                                    <td colSpan="6">Sin Detalles</td>
                                                                </tr>
                                                            ) :
                                                                (
                                                                    listProximosVenc.map((item) => (
                                                                        <tr key={item.IdPrestamo}  style={{ background: getColor(item.Estado) }}>
                                                                            
                                                                            <td>{formatearFecha(item.FechaVencimiento)}</td>
                                                                            <td>{item.Estado}</td>
                                                                            <td>{item.IdPrestamo}</td>
                                                                            <td>{item.Cliente}</td>
                                                                            <td>{item.CuotaOriginal}</td>
                                                                            <td>{item.CoutaConInteres}</td>
                                                                        </tr>
                                                                    ))
                                                                )


                                                        }
                                                    </tbody>
                                                </Table>
          </Card.Body>
        </Card>
      </Container>
    </>
  )
}

export default ProximosVencimientos